<template>
    <div>
        <div v-if="!getMember.inscriptions || !getMember.inscriptions.length>0">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-body">
                            <p>
                                Pas de stages, examens ou formations pour ce membre
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <form role="form" v-if="getMember.inscriptions && getMember.inscriptions.length>0">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <b-col md="9" class="my-1">
                                <h3 class="box-title">Stages, Examens et Formations ({{getMember.inscriptions.length}} formations/examens)</h3>

                            </b-col>
                            <b-col md="3" class="my-1">
                                <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
                            </b-col>

                        </div>
                        <div class="box-body">

                            <b-table
                                    id="tableListingStageFormations"
                                    responsive bordered striped hover
                                    :items="orderByDate(getMember.inscriptions)"
                                    :fields="columns"
                                    :filter="filter"
                                    :current-page="pagination_meta.current_page"
                                    :per-page="pagination_meta.per_page"
                                    :sort-compare="sortCompareAdvanced"
                                    :empty-text="'Aucun résultat'"
                                    :empty-filtered-text="'Aucun résultat'"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    foot-clone
                                    show-empty
                            >

                                <template slot="id" slot-scope="row">
                                    {{ row.item.id | idFormat }}
                                </template>
                                <template slot="formation.titre" slot-scope="row">
                                   <router-link
                                           :to="{ name: 'Formation', params: { formation_id: row.item.formation.id }}">
                                       {{ row.item.formation.titre }}
                                   </router-link>
                                </template>
                                <template slot="inscription" slot-scope="row">
                                    {{ row.item.inscription == 1 ? "OUI" : "NON" }}
                                </template>
                                <template slot="payement" slot-scope="row">
                                    {{ row.item.payement == 1 ? "OUI" : "NON" }}
                                </template>
                                <template slot="repassage" slot-scope="row">
                                    {{ row.item.repassage == 1 ? "OUI" : "NON" }}
                                </template>
                                <template slot="reussite" slot-scope="row">
                                    {{ row.item.reussite == 1 ? "OUI" : "NON" }}
                                </template>
                                <template slot="montant" slot-scope="row">
                                    {{ row.item.montant }}€
                                </template>

                                <template slot="formation.date" slot-scope="data">
                                    {{ formatDate(data.item.formation.date,'YYYY-MM-DD','DD/MM/YYYY') }}
                                </template>

                                <template slot="dateInscription" slot-scope="row">
                                    {{ formatDate(row.item.dateInscription,'YYYY-MM-DD','DD/MM/YYYY') }}
                                </template>

                                <template slot="datePayement" slot-scope="row">
                                    {{ formatDate(row.item.datePayement,'YYYY-MM-DD','DD/MM/YYYY') }}
                                </template>

                                <template slot="created_at" slot-scope="row">
                                    {{ row.item.date }}
                                </template>

                            </b-table>
                            <b-pagination size="md"
                                          :total-rows="getMember.inscriptions.length"
                                          v-model="pagination_meta.current_page"
                                          :per-page="pagination_meta.per_page">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import Datepicker from 'vuejs-datepicker';

    var $ = require('jquery');
    var variables = require('../../../assets/js/variables')
    var _ = require('underscore')
    var moment = require('moment')

    export default {
        data() {
            return {
                sortBy: 'formation.date',
                sortDesc: true,
                filter: null,
                dataTableLicencesMember: null,
                pagination_meta: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    path: "",
                    per_page: 20,
                    to: 1,
                    total: 1
                },
                columns: [
                    {
                        label: 'Identifiant',
                        key: 'id',
                        sortable: true,
                    },
                    {
                        label: 'Date',
                        key: 'formation.date',
                        sortable: true,
                    },
                    {
                        label: 'Formation',
                        key: 'formation.titre',
                        sortable: true,
                    },
                    {
                        label: 'Inscription',
                        key: 'inscription',
                        sortable: true,
                    },
                    {
                        label: 'Date d\'inscription',
                        key: 'dateInscription',
                        sortable: true,
                    },
                    {
                        label: 'Payement',
                        key: 'payement',
                        sortable: true,
                    },
                    {
                        label: 'Date de payement',
                        key: 'datePayement',
                        sortable: true,
                    },
                    {
                        label: 'Montant',
                        key: 'montant',
                        sortable: true,
                    },
                    {
                        label: 'Diplôme',
                        key: 'diplome.grade',
                        sortable: true,
                    },
                    {
                        label: 'Repassage',
                        key: 'repassage',
                        sortable: true,
                    },
                    {
                        label: 'Réussite',
                        key: 'reussite',
                        sortable: true,
                    },
                    {
                        label: 'Commentaires',
                        key: 'comments',
                        sortable: true,
                    },
                    {
                        label: 'Action',
                        key: 'actions',
                        sortable: true,
                    },
                ]
            }
        },
        computed: {
            ...mapGetters({
                getMember: 'getMember'
            }),
        },
        mounted: function () {
            var these = this

        },
        created() {
        },
        watch: {},
        components: {},
        methods: {
            ...mapActions({}),
            flatten: function (obj) {
                var root = {};
                (function tree(obj, index) {
                    var suffix = toString.call(obj) == "[object Array]" ? "]" : "";
                    for (var key in obj) {
                        if (!obj.hasOwnProperty(key)) continue;
                        root[index + key + suffix] = obj[key];
                        if (toString.call(obj[key]) == "[object Array]") tree(obj[key], index + key + suffix + "[");
                        if (toString.call(obj[key]) == "[object Object]") tree(obj[key], index + key + suffix + ".");
                    }
                })(obj, "");
                return root;
            },
            orderByDate:function(inscriptions) {
                return _.sortBy(inscriptions, function (inscription) {
                    return inscription.formation.date
                }).reverse()
            },
            sortCompareAdvanced: function (a, b, key) {
                if (typeof a[key] === 'number' && typeof b[key] === 'number') {
                    // If both compared fields are native numbers
                    return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
                } else {
                    // Stringify the field data and use String.localeCompare
                    return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
                        numeric: true
                    })
                }
            },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },
        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Membre/ListingStageExamensFormations.vue